export const SET_CURRENT_TAKEY_CUISINE = 'SET_CURRENT_TAKEY_CUISINE';
export const CLEAR_CURRENT_TAKEY_CUISINE = 'CLEAR_CURRENT_TAKEY_CUISINE';